import { addDays, endOfDay, startOfDay } from 'date-fns';

import { CrmTaskStatus } from '@plato/data/prisma';
import type { CrmTaskFilterOptions } from '../../../server/dto/crm-task-dto.ts';
import type { TaskViewGroup } from '../types/task-group.ts';
import { useTaskListFilters } from './use-task-filters-state.ts';

export function useTaskQueryBuilder(group: TaskViewGroup) {
    const { appliedFilters } = useTaskListFilters();

    const defaultFilter = {
        ...appliedFilters,
        status: CrmTaskStatus.OPEN,
    } satisfies CrmTaskFilterOptions;

    const now = new Date();

    let filter: CrmTaskFilterOptions;

    switch (group) {
        case 'today': {
            filter = {
                dueDate: [
                    {
                        direction: 'LT',
                        timestamp: endOfDay(now).toISOString(),
                    },
                ],
            };
            break;
        }
        case 'upcoming': {
            filter = {
                ...defaultFilter,
                dueDate: [
                    {
                        direction: 'GTE',
                        timestamp: startOfDay(addDays(now, 1)).toISOString(),
                    },
                ],
            };
            break;
        }
        case 'completed': {
            filter = {
                ...defaultFilter,
                status: CrmTaskStatus.COMPLETED,
            };
            break;
        }
        default: {
            filter = {};
        }
    }

    return {
        ...defaultFilter,
        ...filter,
    } as CrmTaskFilterOptions;
}
